<template>
  <div class="xiaodang-yihuan">
    <!-- head -->
    <header class="yihuan-header">
      <div class="logo">
        <div class="logo-img">
          <img :src="logo" alt="">
        </div>
        <div class="logo-desc">
          <p class="desc-title">小当易换</p>
          <p class="desc-detail">省心划算 当换就换</p>
        </div>
      </div>
    </header>
    <main class="yihuan-main">
      <div class="main-left">
        <img :src="phone" alt="">
      </div>
      <div class="main-right">
        <div class="right-title">
          小当易换
        </div>
        <div class="desc-content">
          <div class="desc-item" v-for="item in descList" :key="item.text">
            <img :src="item.img" alt="">
            <span>{{ item.text }}</span>
          </div>
        </div>
        <!-- 二维码 -->
        <div class="img-content">
          <div class="code-img">
            <img :src="codeImg" alt="">
          </div>
          <img  class="android-img" :src="androidImg" alt="">
        </div>
        <!-- 联系我们 -->
        <div class="connection-content">
          <p class="title">联系我们</p>
          <p class="address">公司地址：广东省深圳市南山区粤海街道高新社区粤兴六道中科纳能大厦A栋5楼</p>
          <p class="phone">联系电话：400-125-0080</p>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bgImg: require('@/assets/image/xdyhDetail/bg.png'),
      logo: require('@/assets/image/xdyhDetail/logo.png'),
      phone: require('@/assets/image/xdyhDetail/phone.png'),
      descList: [
        {
          text: '官方保证',
          img: require('@/assets/image/xdyhDetail/authority.png')
        },
        {
          text: '旧机换新',
          img: require('@/assets/image/xdyhDetail/exchange.png')
        },
        {
          text: '极致高价',
          img: require('@/assets/image/xdyhDetail/price.png')
        },
        {
          text: '顺丰包邮',
          img: require('@/assets/image/xdyhDetail/logistics.png')
        }
      ],
      codeImg: require('@/assets/image/head/xiaodangyihuan.jpg'),
      androidImg: require('@/assets/image/xdyhDetail/android.png')
    }
  }
}
</script>
<style lang="less" scoped>
// @media (max-width: 1500px) {
//   .xiaodang-yihuan{
//     min-height: 800PX;
//   }
// }
@media (min-width: 1600px) {
  .xiaodang-yihuan{
    // min-height: calc(100vw / 1.78);
    min-height: 900PX !important;
  }
}
.xiaodang-yihuan{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  min-width: 1200PX;
  min-height: 800PX;
  // min-height: 675PX;
  // min-height: calc(100vw / 1.78);
  position: relative;
  background-image: url('../assets/image/xdyhDetail/bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  // background-attachment: fixed;
  overflow: hidden;
  .bg-img{
    position: relative;
    width: 100%;
    height: 100%;
    min-width: 1200PX;
    min-height: 675PX;
    img{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      min-width: 1200PX;
      height: auto;
      // min-height: 675PX;
      z-index: -2;
    }
  }
  .yihuan-header{
    padding: 5.6vh 0 0 5.6vh;
    box-sizing: border-box;
    .logo{
      display: flex;
      .logo-img{
        width: 56PX;
        height: 56PX;
        img{
          width: 100%;
        }
      }
      .logo-desc{
        margin-left: 12PX;
        text-align: left;
        .desc-title{
          margin-top: 5PX;
          font-size: 18PX;
          font-weight: 500;
          line-height: 25.2PX;
        }
        .desc-detail{
          font-size: 14PX;
          font-weight: 400;
          line-height: 19.6PX;
        }
      }
    }
  }
  .yihuan-main{
    margin-top: 6.3vh;
    display: flex;
    justify-content: space-evenly;
    padding-bottom: 6.3vh;
    .main-left{
      img{
        width: 16.5vw;//317PX;
        // height: 64.8%;// 700PX;
        // width: 16vW;
        max-width: 317PX;
        min-width: 265PX;
        max-height: 100%;
      }
    }
    .main-right{
      .right-title{
        margin-top: 6.5%;
        font-size: 36PX;
        line-height: 50.4PX;
      }
      .desc-content{
        // width: 800PX;
        width: 41.7vw;
        min-width: 500PX;
        // height: 76PX;
        height: 7vh;
        min-height: 47.5PX;
        // line-height: 96PX;
        line-height: 8.9vh;
        // margin: 28PX auto 0;
        margin: 2.6vh auto 0;
        display: flex;
        justify-content: space-around;
        border-radius: 12PX;
        border: 1px solid #FFF;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.70) -21.05%, rgba(255, 255, 255, 0.00) 465.79%);
        backdrop-filter: blur(18.399999618530273px);
        .desc-item{
          display: flex;
          align-items: center;
          img{
            width: 32PX;
            height: 32PX;
          }
          span{
            margin-left: 6PX;
            font-size: 18PX;
            font-weight: 500;
          }
        }
      }
      .img-content{
        // margin-top: 59PX;
        margin-top: 5.5vh;
        .code-img{
          margin: 0 auto;
          width: 136PX;
          height: 136PX;
          padding: 6PX;
          background: #fff;
          border-radius: 10PX;
          box-sizing: border-box;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .android-img{
          width: 136PX;
          height: 40PX;
          margin-top: 20PX;
        }
      }
      .connection-content{
        // margin-top: 59PX;
        margin-top: 5.5vh;
        .title{
          margin-bottom: 12PX;
          color: #323232;
          font-size: 18PX;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        .address,.phone{
          color: #979797;
          font-size: 18PX;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
  }
}
</style>
